import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, Article } from "../utils/api";

const Articles: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const data = await api.getArticles();
        setArticles(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="wrapper">
        <div className="content-page">
          <article className="articles">
            <h1>Articles</h1>
            <p>Loading articles...</p>
          </article>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="wrapper">
        <div className="content-page">
          <article className="articles">
            <h1>Articles</h1>
            <p>Error loading articles: {error}</p>
          </article>
        </div>
      </div>
    );
  }

  return (
    <div className="wrapper">
      <div className="content-page">
        <article className="articles">
          <h1>Articles</h1>
          <div className="articles-list">
            {articles.map((article) => (
              <div key={article.id} className="article-item">
                <Link to={`/article/${article.slug}`} className="article-link">
                  <div className="article-content">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="article-image"
                    />
                    <div className="article-info">
                      <h2 className="article-title">{article.title}</h2>
                      <p className="article-date">
                        {formatDate(article.createdAt)}
                      </p>
                      <p className="article-description">
                        {article.metaDescription}
                      </p>
                      <div className="article-tags">
                        {article.tags.map((tag) => (
                          <span key={tag} className="tag">
                            #{tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
};

export default Articles;
